<template>
  <h1 class="product__title h4">
    {{ product.title }}
  </h1>

  <!-- <button
    class="product__wishlist absolute top-0 right-0 flex items-center justify-center"
    aria-label="Add to wishlist"
  >
    <HeartIcon />
  </button> -->

  <div class="product__price-line flex items-center">
    <p class="product__price">
      {{ priceFormatted }}
      <s v-if="compareAtPrice">
        {{ compareAtPrice }}
      </s>
    </p>
    <YotpoStars
      v-if="isCombinedListingsProduct"
      :product="combinedListingsProduct"
    />
    <YotpoStars
      v-else
      :product="product"
    />
  </div>
  <div
    v-if="instalments.enabled"
    class="product__instalments flex items-center"
  >
    <KlarnaIcon v-if="instalments.provider === 'klarna'" />
    <AfterpayIcon v-if="instalments.provider === 'afterpay'" />
    <ClearpayIcon v-if="instalments.provider === 'clearpay'" />
    <p v-html="instalmentsText" />
  </div>

  <div
    v-if="badges"
    class="product__badges flex flex-wrap"
  >
    <div
      v-for="(badge, index) in badges"
      :key="`${product.handle}-badge-${index}`"
      class="product-badge"
    >
      {{ badge }}
    </div>
  </div>

  <div
    v-if="shortDescription"
    class="product__short-description rte"
  >
    <p>{{ shortDescription }}</p>
  </div>

  <div
    v-if="flavourCollectionSize > 1"
    class="product__flavour-collection"
  >
    <h2 class="product__label">
      {{ titles.chooseServing }}
    </h2>

    <ul class="product__flavour-colleciton-list text-center flex">
      <li
        v-for="flavourCollectionProduct in flavourCollection.products"
        :key="flavourCollectionProduct.handle"
        class="product__flavour-collection-list-item"
        :class="{ 'product__flavour-collection-list-item--active': flavourCollectionProduct.handle === product.handle }"
      >
        <a :href="`/products/${flavourCollectionProduct.handle}`">
          <div class="product__flavour-collection-list-item-image">
            <img
              :src="flavourCollectionProduct.image"
              :alt="`${ flavourCollectionProduct.title }-image`"
              width="34"
            >
          </div>
          <h3 class="product__flavour-collection-list-item-title xs">
            {{ flavourCollectionProduct.title }}
          </h3>
        </a>
      </li>
    </ul>
  </div>

  <div class="product__variant-collection">
    <h2 class="product__label">
      {{ variantCollectionTitle }}
    </h2>

    <button
      class="variant-collection-dropdown-proxy sm flex justify-between items-center bg-white border-2 border-black hover:border-red"
      @click="openSlideout"
    >
      <img
        :key="`${product.handle}-flavour-dropdown-image`"
        :src="variantCollectionDropdownImage"
        :alt="`${product.handle}-flavour-dropdown-image`"
        width="24"
      >
      {{ variantCollectionDropdownVariantTitle.split(' / ')[0] }}
      <ChevronRightIcon />
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '../../pinia/ProductStore'
import { useVariantCollectionStore } from '../../pinia/VariantCollectionStore'

import { productPrice } from '../../helpers/product'

// import HeartIcon from '../../icons/heart-icon'
import KlarnaIcon from '../../icons/klarna-icon'
import AfterpayIcon from '../../icons/afterpay-icon'
import ClearpayIcon from '../../icons/clearpay-icon'
import ChevronRightIcon from '../../icons/chevron-right'

import YotpoStars from '../../components/product-yotpo-stars'

export default {
  components: {
    // HeartIcon,
    KlarnaIcon,
    AfterpayIcon,
    ClearpayIcon,
    ChevronRightIcon,
    YotpoStars
  },
  props: {
    instalments: {
      type: Object,
      default: () => {
        return {
          enabled: false
        }
      }
    },
    titles: {
      type: Object,
      default: null
    },
    variantCollectionIsFlavourDropdown: {
      type: Boolean,
      default: false
    },
    isCombinedListingsProduct: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      products: [],
      flavourCollections: [...window.theme.flavourCollections]
    }
  },
  computed: {
    ...mapState (useProductStore, [
      'product',
      'priceFormatted',
      'badges',
      'shortDescription',
      'flavourCollectionHandle',
      'variantCollectionTriggerImage',
      'variantTriggerImage',
      'selectedVariant',
      'combinedListingsProduct'
    ]),

    variantCollectionDropdownImage () {
      if (this.isCombinedListingsProduct) {
        return this.variantTriggerImage
      } else {
        return this.variantCollectionTriggerImage
      }
    },

    variantCollectionDropdownVariantTitle () {
      if (this.isCombinedListingsProduct) {
        return this.selectedVariant.title.toLowerCase()
      } else {
        return this.product.title.toLowerCase()
      }
    },

    flavourCollection () {
      if (this.flavourCollectionHandle) {
        return this.flavourCollections?.find(collection => collection.handle === this.flavourCollectionHandle)
      }
      return null
    },

    flavourCollectionSize () {
      if (this.flavourCollectionHandle) {
        return this.flavourCollection?.products?.length
      }
      return 0
    },

    variantCollectionTitle () {
      if (this.variantCollectionIsFlavourDropdown) {
        return this.titles.chooseFlavour
      } else if (this.productType === 'shaker') {
        return this.titles.chooseShaker
      } else if (this.isCombinedListingsProduct) {
        return this.titles.chooseVariant
      } else {
        return 'Select:'
      }
    },

    instalmentsText () {
      if (this.instalments.enabled) {
        const instalmentsPrice = productPrice(this.product.price / this.instalments.amount)
        return this.instalments.text.replace('[AMOUNT]', this.instalments.amount)
          .replace('[PRICE]', instalmentsPrice)
      }
      return null
    },

    compareAtPrice () {
      return this.product.compare_at_price && this.product.compare_at_price > this.product.price ? productPrice(this.product.compare_at_price) : null
    },
  },
  methods: {
    ...mapActions(useVariantCollectionStore, [
      'openSlideout'
    ]),
  }
}
</script>
